"use strict";

/* Directives */
_BannerFlowApp.directive("breadcrumbs", function ($state, $timeout) {
    return {
        restrict: "E",
        replace: true,
        require: "ngModel",
        scope: {
            route: "@?",
            root: "@?",
            rootRoute: "@?",
            click: "&?",
            rootClick: "&?",
            slim: "=?",
            itemsDropped: "&?",
            showTrailingArrow: "&?",
            limitAmount: "@?",
            truncateOverflow: "&?"
        },
        link: function ($scope, elem, $attrs, modelCtrl) {
            var watcher = null;

            $scope.model = {
                state: $state
            };

            $scope.model.hiddenCrumbs = false;
            var checkCrumbs = false;

            $scope.$watch(
                function () {
                    return modelCtrl.$modelValue;
                },
                function (newVal, oldVal) {
                    if (!newVal) return;

                    $scope.model.crumbs = angular.copy(newVal);

                    for (var i = 0; i < $scope.model.crumbs.length; i++) {
                        if ($scope.route) {
                            $scope.model.crumbs[i].route = $scope.route.format(
                                "{ folderId: '" + $scope.model.crumbs[i].id + "' }"
                            );
                        }

                        if (
                            $scope.model.crumbs.length > 2 &&
                            i != $scope.model.crumbs.length - 1 &&
                            $scope.model.crumbs[i].name.length > 8
                        ) {
                            $scope.model.crumbs[i].name =
                                $scope.model.crumbs[i].name.substring(0, 8) + "...";
                        } else if ($scope.model.crumbs[i].name.length > 20) {
                            $scope.model.crumbs[i].name =
                                $scope.model.crumbs[i].name.substring(0, 20) + "...";
                        }
                    }

                    $timeout(function () {
                        // Do this only once (only second time this is executed)
                        if ($scope.truncateOverflow && checkCrumbs) {
                            var hiddenCrumbsPath = [];
                            var crumbArrowWidth = 20;

                            var crumbs = $(".crumb:not(.root, .crumbs-hidden)");

                            function each(i) {
                                var crumb = crumbs[i];

                                var lastCrumb = $(".crumb").last()[0];

                                if (
                                    lastCrumb.offsetLeft + lastCrumb.offsetWidth + crumbArrowWidth >
                                    $(".breadcrumbs").width()
                                ) {
                                    $(crumb).hide();
                                    hiddenCrumbsPath.push($(crumb).text());
                                }

                                if (i >= crumbs.length) {
                                    // Show breadcrumbs, it's hidden by default in banner set
                                    $(".breadcrumbs").css("opacity", 1);
                                    return;
                                }

                                i++;
                                $timeout(function () {
                                    each(i);
                                }, 1);
                            }
                            each(0);

                            if (hiddenCrumbsPath.length) {
                                $scope.model.hiddenCrumbs = true;
                            }
                            $(".crumb.crumbs-hidden").attr("title", hiddenCrumbsPath);
                        }
                        checkCrumbs = true;

                        $(".crumb:not(:last-child)", elem).droppable({
                            drop: function (e, ui) {
                                if ($scope.itemsDropped) {
                                    var objects = [];
                                    var that = this;

                                    $("tr.ui-selected", $(ui.draggable).closest(".table")).each(
                                        function () {
                                            if ($(that).is(this)) {
                                                conflict = true;
                                            }

                                            var row = angular.element(this).scope().row;
                                            objects.push(row);
                                        }
                                    );

                                    var folder = angular.element(this).scope().crumb
                                        ? angular.element(this).scope().crumb.id
                                        : null;

                                    $scope.$apply(function () {
                                        $scope.itemsDropped()(folder, objects);
                                    });
                                }
                            },
                            tolerance: "pointer",
                            hoverClass: "ui-state-highlight"
                        });
                    }, 100);
                },
                true
            );
        },
        template:
            '<div class="breadcrumbs" ng-class="{ slim: slim, \'trailing-arrow\': showTrailingArrow }">' +
            '<div class="crumb-list" ng-if="rootRoute">' +
            '<div class="crumb root" ui-sref="{{ rootRoute }}">{{ root }}</div>' +
            '<i ng-if="model.hiddenCrumbs" class="trailingArrow crumbs-hidden bf-icon bf-icon-arrow-right-b"></i>' +
            '<div class="crumb crumbs-hidden" ng-show="model.hiddenCrumbs" style="cursor: default;">...</div>' +
            '<div class="crumb" ui-sref="{{ crumb.route }}" ng-repeat="crumb in model.crumbs"><i class="bf-icon bf-icon-arrow-right-b"></i><span>{{ crumb.name }}</span></div>' +
            '<i ng-if="showTrailingArrow" class="trailingArrow bf-icon bf-icon-arrow-right-b"></i>' +
            '<div class="clearfix"></div>' +
            "</div>" +
            '<div class="crumb-list" ng-if="!rootRoute && !limitAmount">' +
            '<div class="crumb root" ng-click="rootClick()">{{ root }}</div>' +
            '<div class="crumb" ng-click="click(crumb)" ng-repeat="crumb in model.crumbs"><i class="bf-icon bf-icon-arrow-right-b"></i><span>{{ crumb.name }}</span></div>' +
            '<i ng-if="showTrailingArrow" class="trailingArrow bf-icon bf-icon-arrow-right-b"></i>' +
            '<div class="clearfix"></div>' +
            "</div>" +
            '<div class="crumb-list" ng-if="limitAmount">' +
            '<div class="crumb root" ng-click="rootClick()">{{ root }}</div>' +
            '<div class="crumb" ng-click="click(crumb)" ng-repeat="crumb in model.crumbs | limitTo: -5"><i class="bf-icon bf-icon-arrow-right-b"></i><span>{{ crumb.name }}</span></div>' +
            '<i ng-if="showTrailingArrow" class="trailingArrow bf-icon bf-icon-arrow-right-b"></i>' +
            '<div class="clearfix"></div>' +
            "</div>" +
            '<div class="clearfix"></div>' +
            "</div>"
    };
});
